import { useEffect, useState } from 'react'

export enum ScrollDirection {
	UP = 'UP',
	DOWN = 'DOWN'
}

const useScrollDirection = ({
	initialDirection = ScrollDirection.UP,
	thresholdPixels = 50
}: {
	initialDirection?: ScrollDirection
	thresholdPixels?: number
} = {}) => {
	const [scrollDir, setScrollDir] = useState(initialDirection)

	useEffect(() => {
		const threshold = thresholdPixels || 0
		let lastScrollY = window.pageYOffset
		let ticking = false

		const updateScrollDir = () => {
			const scrollY = window.pageYOffset

			if (Math.abs(scrollY - lastScrollY) < threshold) {
				ticking = false
				return
			}

			setScrollDir(
				scrollY > lastScrollY ? ScrollDirection.DOWN : ScrollDirection.UP
			)
			lastScrollY = scrollY > 0 ? scrollY : 0
			ticking = false
		}

		const onScroll = () => {
			if (!ticking) {
				window.requestAnimationFrame(updateScrollDir)
				ticking = true
			}
		}

		window.addEventListener('scroll', onScroll)

		return () => window.removeEventListener('scroll', onScroll)
	}, [initialDirection, thresholdPixels])

	return scrollDir
}

export default useScrollDirection
